import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import Pagination from "../../../partials/content/Pagination";

export default function AllTransactionScoreToWalletAdvertiser() {
  const [
    allTransactionScoreToWalletAdvertiser,
    setAllTransactionScoreToWalletAdvertiser,
  ] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [
    transactionScoreToWalletAdvertiserID,
    setTransactionScoreToWalletAdvertiser,
  ] = useState(0);

  useEffect(() => {
    getAllTransactionScoreToWalletAdvertiser();
  }, [currentPage, transactionScoreToWalletAdvertiserID]);

  const getAllTransactionScoreToWalletAdvertiser = async () => {
    const userID = parseInt(document.querySelector("#user-id").value);
    if (!userID) {
      return;
    }
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allTransactionScoreToWalletAdvertiser =
      await sendRequestGetAllTransactionScoreToWalletAdvertiser(
        userID,
        searchFilterQuery
      );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allTransactionScoreToWalletAdvertiser) {
      return;
    }

    setCountPage(allTransactionScoreToWalletAdvertiser.count_page);
    setAllTransactionScoreToWalletAdvertiser(
      allTransactionScoreToWalletAdvertiser.transaction_score
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (transactionScoreToWalletAdvertiserID) {
      searchFilterQuery = `${searchFilterQuery}&id=${transactionScoreToWalletAdvertiserID}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllTransactionScoreToWalletAdvertiser = async (
    userPublisherID,
    searchFilterQuery
  ) => {
    const headersRequest = getHeaderRequest();
    let allTransactionScoreToWalletAdvertiser;
    try {
      allTransactionScoreToWalletAdvertiser = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/publisher/transaction-score-to-wallet-advertiser/${userPublisherID}/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allTransactionScoreToWalletAdvertiser.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAllTransactionScoreToWalletAdvertiser = () => {
    return (
      <div className="pb-4 px-2">
        <div className="alert alert-info mt-2">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره </label>
              </div>
              <div>
                <input
                  onKeyUp={(e) =>
                    setTransactionScoreToWalletAdvertiser(e.target.value)
                  }
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تبدیل</td>
                <td>Hicoin</td>
                <td>شارژ تبلیغ دهنده (تومان)</td>
                <td>تاربخ درج</td>
              </tr>
            </thead>
            <tbody>
              {allTransactionScoreToWalletAdvertiser.map((item, index) => {
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(item.pts_id)}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(
                          item.pts_score_publisher
                        )
                      )}
                    </td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(
                          item.pts_wallet_advertiser
                        )
                      )}
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        item.pts_created_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            item.pts_created_at.split(" ")[0]
                          )
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </div>
    );
  };

  const generateUserPublisherDoseNotHaveAnyTransactionScoreToWalletAdvertiser =
    () => {
      return (
        <div className="pt-2">
          <div className="alert alert-info">
            این کاربر هیچ گزارش تبدیل Hicoin به موجودی تبلیغ دهنده ندارد.
          </div>
        </div>
      );
    };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="all-transaction-score" />

      <div className="content-wrapper">
        <TitleBar title="گزارش تبدیل Hicoin کاربر نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="w-50">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    getAllTransactionScoreToWalletAdvertiser();
                  }}
                >
                  <div class="input-group ">
                    <input
                      type="number"
                      id="user-id"
                      class="form-control"
                      placeholder="شماره کاربر نمایش دهنده را وارد کنید."
                      required
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">
                        نمایش
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div>
                {allTransactionScoreToWalletAdvertiser.length == 0 &&
                !transactionScoreToWalletAdvertiserID
                  ? generateUserPublisherDoseNotHaveAnyTransactionScoreToWalletAdvertiser()
                  : generateAllTransactionScoreToWalletAdvertiser()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
